export default __webpack_public_path__ + "static/media/monetizze.alt.015d67a5.png";